import React, { Component } from "react";
import PropTypes from "prop-types";
import LineSeries from "./LineSeries";

/**
 * BIAS (Fechamento menos MA, FML.BIAS) — painel próprio, 3 linhas: BIAS1,
 * BIAS2 e BIAS3. yAccessor(d) retorna { bias1, bias2, bias3 }.
 */
class BIASSeries extends Component {
  constructor(props) {
    super(props);
    this.bias1Accessor = this.bias1Accessor.bind(this);
    this.bias2Accessor = this.bias2Accessor.bind(this);
    this.bias3Accessor = this.bias3Accessor.bind(this);
  }
  bias1Accessor(d) {
    const v = this.props.yAccessor(d);
    return v && v.bias1;
  }
  bias2Accessor(d) {
    const v = this.props.yAccessor(d);
    return v && v.bias2;
  }
  bias3Accessor(d) {
    const v = this.props.yAccessor(d);
    return v && v.bias3;
  }
  render() {
    const { strokeBias1, strokeBias2, strokeBias3, className } = this.props;
    return (
      <g className={className}>
        <LineSeries
          yAccessor={this.bias1Accessor}
          stroke={strokeBias1}
          fill="none"
        />
        <LineSeries
          yAccessor={this.bias2Accessor}
          stroke={strokeBias2}
          fill="none"
        />
        <LineSeries
          yAccessor={this.bias3Accessor}
          stroke={strokeBias3}
          fill="none"
        />
      </g>
    );
  }
}

BIASSeries.propTypes = {
  yAccessor: PropTypes.func.isRequired,
  strokeBias1: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  strokeBias2: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  strokeBias3: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  className: PropTypes.string,
};

BIASSeries.defaultProps = {
  strokeBias1: { color: "#FFFF00" },
  strokeBias2: { color: "#FF0000" },
  strokeBias3: { color: "#0000B4" },
  className: "react-stockcharts-bias-series",
};

export default BIASSeries;
